// extracted by mini-css-extract-plugin
export default {"wrapper":"b_WpBi","wrapper--visible":"N5FAWn"};